import { hash } from '@ember/helper';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsCoopPartnerComponent extends Component {
  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='name' />
            <fieldset.field @property='city' />
            <fieldset.field @property='street' />
            <fieldset.field @property='zipcode' />

            <fieldset.field @property='phone' />
            <fieldset.field @property='email' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='configuration' as |fieldset|>
            <fieldset.field
              @filters={{hash type='P_TYPE_COOP'}}
              @property='coopTypes'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
